// src/utils/customerChatId.js
//
// The id of a customer live chat (customerChats/{id}). For the anonymous consumer-site widget the id is the
// visitor's ONLY key to their conversation (firestore.rules customerChats), so it must not be guessable:
// 128 bits from the browser's CSPRNG. It used to be `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
// a millisecond timestamp plus ~31 bits, which a script could walk (bug EPG70jjinwUHBWIwwxBN, 2026-10-04).
// getRandomValues rather than randomUUID: the public widget runs on whatever browser a visitor brings.

/**
 * @param {'visitor'|'portal'} kind - which widget opens the chat (the prefix the rules read)
 * @returns {string} e.g. `visitor_1790703350689_9f2c…` (32 hex characters of randomness)
 */
export function newCustomerChatId(kind) {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16))
  const random = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
  return `${kind}_${Date.now()}_${random}`
}
